export default "__VITE_ASSET__aecdb71b__"